// Styles
import './page-archive.scss';

const siteFooter = document.querySelector('.site-footer');
if (siteFooter) {
  var footerHeight = siteFooter.clientHeight;
  document.querySelector(':root').style.setProperty('--footer-height', footerHeight + 'px');
}
